import { LitElement, css, html } from 'lit';
import { customElement, property, query } from 'lit/decorators';

import { FormInput } from './theme/form-input';

export type AddFolderMenuType = 'rename-folder' | 'add-folder' | 'add-sub-folder';

@customElement('add-edit-folder-modal')
export class AddEditFolderModal extends LitElement {
    private readonly amplitude_callsite: string = 'Folder Add or Edit Modal';

    @query('#folderName')
    folderNameElement!: FormInput;

    @property({ type: String })
    type: AddFolderMenuType = 'add-folder';

    private async handleSubmit(inputValue: string) {
        const folderName = inputValue.trim();
        this.dispatchEvent(
            new CustomEvent(this.type, {
                detail: {
                    name: folderName,
                },
            })
        );
        this.folderNameElement.formInputElement.value = '';
    }

    private async handleSave() {
        if (this.folderNameElement.value) {
            await this.handleSubmit(this.folderNameElement.value);
        }
    }

    private async handleCancel() {
        this.dispatchEvent(new CustomEvent('close'));
    }

    get modalTitle(): string {
        switch(this.type) {
            case 'rename-folder':
                return 'Rename Folder';
            case 'add-folder':
                return 'Add Folder';
            default:
                return 'Add Sub Folder';
        }
    }

    render() {
        return html`
            <div class="folderModalContent">
                <h2 id="modalTitle">
                    ${this.modalTitle}
                </h2>
                <div>
                    <form-input
                        id="folderName"
                        type="text"
                        placeholder="Input Folder Name"
                        maxLength="35"
                        @submit="${async (e: any) => await this.handleSubmit(e.detail)}"
                    >
                    </form-input>
                </div>
                <div class="actionButtonsWrapper">
                    <form-button variant="social" @click="${this.handleCancel}">
                        Cancel
                    </form-button>
                    <form-button class="form-btn" @click="${this.handleSave}"> Save </form-button>
                </div>
                <error-toast id="errorToast"></error-toast>
                <div></div>
            </div>
        `;
    }

    static get styles() {
        return css`
            .folderModalContent {
                padding: 0.5rem 1.5rem 1rem;
            }

            #modalTitle {
                margin-bottom: 1.25rem;
                color: var(--main-primary-color);
                display: flex;
                align-items: center;
                justify-content: center;
            }

            mwc-icon {
                width: 2rem;
            }

            #folderName {
                width: 550px;
                max-width: 100%;
                display: block;
            }

            .actionButtonsWrapper {
                margin-top: 1rem;
                display: flex;
                justify-content: space-between;
            }
        `;
    }
}
